(function($){
  var $ = jQuery = $;

  $(document).on('click', '[data-toggle="lightbox"]', lity);

  
  /* Google Analytics events */
  // Phone numbers on contact page (handled inline)
  // gtag('event', 'contact', { 'event_category': 'Phone number', 'event_label': 'Australia' });
  // gtag('event', 'contact', { 'event_category': 'Phone number', 'event_label': 'International' });

  
  // Homepage popup video (handled inline)
  // gtag('event', 'play', {'event_category': 'Videos', 'event_label': 'Chern’ee Sutton Bio homepage popup video'});
  
  // Contact form submission (handled inline)
  // gtag('event', 'submit', {'event_category': 'Forms', 'event_label': 'Contact form'});
  
  // PDFs
  $('a[href$=".pdf"]').click(function() {
    var pdf = $(this).attr('href');

    ga('send', 'event', 'PDF', 'download', pdf);
    
    //gtag('event', 'download', {
    //  'event_category': 'PDF',
    //  'event_label': pdf
    //});
  });
  
  // Social links
  $('.social-links a').click(function () {
    var title = $(this).prop('title');
    
    if (title) {
      console.log('social link hit', title);
      ga('send', 'event', 'Social links', 'click', title);
      //gtag('event', 'click', {
      //  'event_category': 'Social links',
      //  'event_label': title
      //});
    }
  });
  
  // Fix for mobile nav kalkadoon link
  $('body').on('click', '.sub-nav-item-link', function(e){
    var $button = $(this).siblings().first();
    if ($button.length
        && ($(this).prop("href").endsWith("/pages/kalkadoon-country") || $(this).prop("href").endsWith("/pages/kalkadoon-country/"))) {
      e.preventDefault();
      $button.click();
    } else {
      console.log('url was actually', $(this).prop("href"));
    }
  });

})(theme.jQuery);

